export const PROPERTY_SELECT_SUBSCRIPTION = 'select_subscription';
export const TYPE_MEMBERSHIP_MANAGEMENT = 'membership_management';
export const TYPE_ONBOARDING = 'onboarding';
